// extracted by mini-css-extract-plugin
export var sliderRange = "_n3-2";
export var sliderRoot = "_n3-0";
export var sliderThumb = "_n3-3";
export var sliderTrack = "_n3-1";